import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialMdcModule } from 'src/app/shared/material-mdc.module';
import { ConfirmCartMobileComponent } from './confirm-cart-mobile.component';


@NgModule({
  declarations: [ConfirmCartMobileComponent],
  exports: [
    ConfirmCartMobileComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialMdcModule
  ]
})
export class ConfirmCartMobileModule {
}
